module.exports = __webpack_public_path__ + "img/6. Learning Material_1.49a2840f.jpg";